module.exports = __webpack_public_path__ + "img/ppjs—icon.10a9b445.png";